import Rx from 'rx';
import moment from 'moment';

export default function MemberPaymentsCtrl($scope, WampCall, progressBar, $state, $anchorScroll, $mdMedia) {

  var uri = 'org.eggs.payments_made';
  var vm = this;

  vm.mdMedia = $mdMedia;

  var s1 = $scope.$createObservableFunction('refresh')
      .startWith('nothing')
      .do(function () {
        vm.trades = {};
        vm.totals = {};
        vm.loadingEgg = true;
        vm.noItems = false;
        progressBar.add(uri);
      })
      .flatMap(function () {
        return new WampCall(uri);
      })
      .do(function (trades) {
        progressBar.remove(uri);
        vm.lastUpdated = moment();
        if (trades.length === 0) {
          vm.noItems = true;
        }
        else {
          vm.loadingEgg = false;
        }
      })
      .flatMap(function (trades) {
        return Rx.Observable.from(trades);
      })
      .groupBy(function (trade) {
        return trade.Comment; //Check Number
      })
      .subscribe(
          function (groupedTrades) {


            //Items
            groupedTrades
                .safeApply($scope, function (trade) {
                  vm.trades[groupedTrades.key] = vm.trades[groupedTrades.key] || [];
                  vm.trades[groupedTrades.key].push(trade);
                   // console.log(trade.Comment.trim() + ', ' + trade.InvoiceNo + ', ' + trade.TradeNo + ', '+ trade.TransDate + ', '+ trade.SellerPrice);
                })
                .subscribe(function () {
                  if ($state.params.id) {
                    $anchorScroll('trade' + $state.params.id);
                  }
                });

            //Totals
            groupedTrades
                .map(function (trade) {
                  return trade.SellerPrice;
                })
                .scan(function (accum, value) {
                  return accum + parseFloat(value);
                }, 0)
                .safeApply($scope, function (total) {
                  vm.totals[groupedTrades.key] = total;
                })
                .subscribe();

          },
          function ($e) {
            vm.noItems = true;
            progressBar.remove(uri);
          });

  $scope.$on('$destroy', function () {
    s1.dispose();
  });
}
